import { useContext } from 'react';
import { LanguageContext } from './context';
import { MobileMenuContext } from './MobileMenuContextDefinition';

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

// Translation hook
export function useTranslation() {
  const { translations } = useLanguage();
  
  const t = (key: string): string => {
    const value = translations[key];
    return typeof value === 'string' ? value : key;
  };
  
  return { t };
}

export function useMobileMenu() {
  const context = useContext(MobileMenuContext);
  if (context === undefined) {
    throw new Error('useMobileMenu must be used within a MobileMenuProvider');
  }
  return context;
}

export function useMobileMenuSafe() {
  const context = useContext(MobileMenuContext);
  return context; // Can be undefined
}